export const SAVE_BOOKING_STEP_URL = "SAVE_BOOKING_STEP_URL";
export const RESET_BOOKING_STEP_URLS = "RESET_BOOKING_STEP_URLS";
